import { ChakraFlex, FAIconName, Icon, Text } from '@equip.health/ui';

type Props = {
  title: string;
  iconName: FAIconName;
};
export const IconTextMenuButtonOption = ({ title, iconName }: Props) => {
  return (
    <ChakraFlex alignItems="center" gap="12px">
      <Icon name={iconName} />
      <Text>{title}</Text>
    </ChakraFlex>
  );
};
